import { DocumentData } from "firebase/firestore";
import { atom } from "recoil";

// 今期直近までと前期の比較合計のデータを管理
export const comparisonsStore = atom<DocumentData>({
  key: "conparisons",
  default: {},
});
